import { WindTurbineAlertIcon } from './WindTurbineAlertIcon';

/**
 * author: Michael Irigoyen
 * id E77F8623-2F40-49A2-AE26-40B7B9AFA6AF
 * name wind-turbine-alert
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wind-turbine-alert.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const WindPowerAlertIcon = WindTurbineAlertIcon;
export default WindPowerAlertIcon